import client from '/src/services/client.js';

export default {
    getConversations : (data) => client.get('conversations/completed', data),
    getConversation : ({id}) => client.get(`conversation/completed/${id}`, {}),
    deleteConversation : (id) => client.delete(`conversation/completed/${id}`),
    getAudioOfConversation : ({id, object_id}) => client.get(`conversation/completed/${id}`, { object_id }),
}
